import { axiosInstance } from "../axios";

export const khoApi = {
  getAll: async () => {
    return await axiosInstance.get("/warehouses/getMyWarehouse");
  },
  getPaginate: (params) =>
    axiosInstance.get("/warehouses/paginate", { params }),
  getById: (id) => axiosInstance.get(`/warehouses/${id}`),
  create: (data) => axiosInstance.post("/warehouses", data),
  update: (id, data) => axiosInstance.put(`/warehouses/${id}`, data),
  delete: (id) => axiosInstance.delete(`/warehouses/${id}`),
};
